export default {
  LIST_ITEM: 'listItem',
};